import React, { useMemo } from 'react';
import { LinkV2, useTheme } from '@withjoy/joykit';
import { StyledFooterWrapper, ParticleJoyLogoWithPadding, getLinkStyles } from './RegistryFooter.styles';
import { useTranslation } from '@shared/core';
import { useColorPaletteProvider } from '@apps/guest/packages/layout-engine/layouts/ColorPaletteProvider/ColorPaletteProvider';
import { getHoverColor } from '@apps/guest/packages/layout-engine/layouts/layout.utils';
import { useJoyBranding } from '@shared/components/JoyLogoLoader/useJoyBranding';

const FOOTER_HELP_URL = 'http://help.withjoy.com/guest-help/?utm_source=guest-site-registry&utm_medium=viral&utm_campaign=registry_help_links';
const FOOTER_ABOUT_URL = 'https://withjoy.com/?utm_source=guest-site-registry&utm_medium=viral&utm_campaign=registry_help_links';

export const RegistryFooter: React.FC = () => {
  const { t2 } = useTranslation('guestRegistry');
  const { help, about } = t2('registryFooter');
  const { colors } = useTheme();
  const { pageFontColor } = useColorPaletteProvider();
  const { linkColor, linkHoverColor } = useMemo(() => {
    const linkColor = pageFontColor || colors.mono10;
    const linkHoverColor = pageFontColor ? getHoverColor(linkColor) : colors.mono14;
    return { linkColor, linkHoverColor };
  }, [pageFontColor, colors.mono10, colors.mono14]);
  const { showJoyLogo } = useJoyBranding();
  const hideFooter = !showJoyLogo;

  if (hideFooter) {
    return null;
  }

  return (
    <StyledFooterWrapper>
      <LinkV2
        href={FOOTER_HELP_URL}
        target="_blank"
        {...getLinkStyles(linkColor, linkHoverColor)}
      >
        {help}
      </LinkV2>
      <ParticleJoyLogoWithPadding
        id="footer2brand-desktop"
        logoColor={linkColor}
        href={FOOTER_ABOUT_URL}
      />
      <LinkV2
        href={FOOTER_ABOUT_URL}
        target="_blank"
        {...getLinkStyles(linkColor, linkHoverColor)}
      >
        {about}
      </LinkV2>
    </StyledFooterWrapper>
  );
};
